/** @jsxImportSource @emotion/react */
import { Tooltip } from "components/general/Tooltip";
import React, { useRef } from "react";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Amount } from "../../types/amount";
import { Text } from "../general/Text";
import { FlexContainer } from "../../containers/FlexContainer";
import LoadingEllipse from "../ButterComponents/LoadingEllipse/LoadingEllipse";
import { withIsVisible } from "../../utils/reactUtils";
import { css } from "@emotion/react";
import { CHAINS } from "config/chains";

const NetworkFeeLabel: React.FC<{ networkFee: Amount }> = ({ networkFee }) => {
  const network = GlobalStore.useState(s => s.network);
  const isRequestingQuote = GlobalStore.useState(s => s.isRequestingQuote);
  const infoRef = useRef<HTMLDivElement>(null);
  const theme = GlobalStore.useState(s => s.theme);
  const SelectedNetworkIcon = CHAINS[network.id].icon;
  const tooltipText =
    "This network cost is known as the network or gas fee and is determined by network demand. It does not go to Bebop.";

  return (
    <div ref={infoRef} data-testid={"network-fee-label"}>
      <FlexContainer>
        <LoadingEllipse isVisible={isRequestingQuote} />
        <Tooltip title={tooltipText}>
          {" "}
          <Text
            size="Large"
            textStyle="Paragraph"
            color={theme.font.tertiary.hover}
            textCss={css`
              display: flex;
              align-items: center;
              gap: 4px;
              flex-shrink: 0;
            `}
          >
            {" "}
            Network cost
            <SelectedNetworkIcon width={16} height={16} />${networkFee.value.toFixed(2)}
          </Text>
        </Tooltip>
      </FlexContainer>
    </div>
  );
};

export default withIsVisible(NetworkFeeLabel);
